import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Nombrar la dificultad",
    opening: localizedGenderNode(
      [
      "Hoy no me obligo a levantarme.",
      "Solo noto: es difícil empezar el día.",
      "Estoy aquí."
    ],
      [
      "Hoy no me obligo a levantarme.",
      "Solo noto: es difícil empezar el día.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pauso conmigo.",
      "Una respiración."
    ],
      [
      "Pauso conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo es la mañana más pesada para mí?",
      "¿Cuál es mi primer pensamiento al abrir los ojos?",
      "¿Qué siento en mi cuerpo?"
    ],
      [
      "¿Cuándo es la mañana más pesada para mí?",
      "¿Cuál es mi primer pensamiento al abrir los ojos?",
      "¿Qué siento en mi cuerpo?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "La dificultad es una experiencia, no soy yo."
    ],
      [
      "La dificultad es una experiencia, no soy yo."
    ]
    ),
    action: localizedGenderNode(
      "una respiración + \"Estoy aquí con la mañana\".",
      "una respiración + \"Estoy aquí con la mañana\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "El primer momento",
    opening: localizedGenderNode(
      [
      "Hoy noto el momento en que empieza la dificultad.",
      "Solo noto.",
      "Me quedo conmigo."
    ],
      [
      "Hoy noto el momento en que empieza la dificultad.",
      "Solo noto.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me siento conmigo un momento.",
      "Una respiración."
    ],
      [
      "Me siento conmigo un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué pasa justo antes de rendirme a levantarme?",
      "¿Dónde me encuentra en la mañana?",
      "¿Qué intento evitar?"
    ],
      [
      "¿Qué pasa justo antes de rendirme a levantarme?",
      "¿Dónde me encuentra en la mañana?",
      "¿Qué intento evitar?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "En el primer momento tengo un poco de espacio."
    ],
      [
      "En el primer momento tengo un poco de espacio."
    ]
    ),
    action: localizedGenderNode(
      "una respiración cuando empieza.",
      "una respiración cuando empieza."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Señales del cuerpo",
    opening: localizedGenderNode(
      [
      "Hoy escucho mi cuerpo antes del pensamiento.",
      "Me quedo conmigo.",
      "Estoy aquí."
    ],
      [
      "Hoy escucho mi cuerpo antes del pensamiento.",
      "Me quedo conmigo.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto mi respiración.",
      "Una respiración."
    ],
      [
      "Noto mi respiración.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde siente mi cuerpo la dificultad?",
      "¿Qué intenta proteger mi cuerpo?",
      "¿Qué podría suavizarse un poco?"
    ],
      [
      "¿Dónde siente mi cuerpo la dificultad?",
      "¿Qué intenta proteger mi cuerpo?",
      "¿Qué podría suavizarse un poco?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Mi cuerpo intenta cuidarme."
    ],
      [
      "Mi cuerpo intenta cuidarme."
    ]
    ),
    action: localizedGenderNode(
      "una mano en el pecho y una respiración.",
      "una mano en el pecho y una respiración."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Historia vs. hecho",
    opening: localizedGenderNode(
      [
      "Hoy separo hecho de historia.",
      "No peleo con la historia.",
      "Me quedo conmigo."
    ],
      [
      "Hoy separo hecho de historia.",
      "No peleo con la historia.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Respiro hacia adentro y hacia afuera.",
      "Una respiración."
    ],
      [
      "Respiro hacia adentro y hacia afuera.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuál es el hecho simple aquí?",
      "¿Qué historia saltó?",
      "¿Qué posibilidad más suave también podría ser cierta?"
    ],
      [
      "¿Cuál es el hecho simple aquí?",
      "¿Qué historia saltó?",
      "¿Qué posibilidad más suave también podría ser cierta?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una historia no soy yo."
    ],
      [
      "Una historia no soy yo."
    ]
    ),
    action: localizedGenderNode(
      "una frase interna - \"Esto es una historia que aparece\".",
      "una frase interna - \"Esto es una historia que aparece\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Lo que se apagó",
    opening: localizedGenderNode(
      [
      "Hoy noto lo que se apagó en mí por la mañana.",
      "No para culpar.",
      "Me quedo conmigo."
    ],
      [
      "Hoy noto lo que se apagó en mí por la mañana.",
      "No para culpar.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento mis pies.",
      "Una respiración."
    ],
      [
      "Siento mis pies.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué suele faltarme por la mañana?",
      "¿Cuándo me siento un poco más vivo/a?",
      "¿Qué extraño?"
    ],
      [
      "¿Qué suele faltarme por la mañana?",
      "¿Cuándo me siento un poco más vivo/a?",
      "¿Qué extraño?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Notar lo que se apagó ya es un vínculo."
    ],
      [
      "Notar lo que se apagó ya es un vínculo."
    ]
    ),
    action: localizedGenderNode(
      "escribir una cosa que extraño.",
      "escribir una cosa que extraño."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Voz interna",
    opening: localizedGenderNode(
      [
      "Hoy escucho mi voz interna.",
      "Sin forzar.",
      "Estoy aquí."
    ],
      [
      "Hoy escucho mi voz interna.",
      "Sin forzar.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Ablando un poco los hombros.",
      "Una respiración."
    ],
      [
      "Ablando un poco los hombros.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué dice mi voz interna sobre levantarme?",
      "¿Qué necesita esa voz de mí?",
      "¿Qué suena más suave dentro de mí?"
    ],
      [
      "¿Qué dice mi voz interna sobre levantarme?",
      "¿Qué necesita esa voz de mí?",
      "¿Qué suena más suave dentro de mí?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una voz interna suave es un comienzo."
    ],
      [
      "Una voz interna suave es un comienzo."
    ]
    ),
    action: localizedGenderNode(
      "una frase interna suave.",
      "una frase interna suave."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Una pequeña necesidad",
    opening: localizedGenderNode(
      [
      "Hoy toco la necesidad debajo de la dificultad.",
      "No resuelvo.",
      "Me quedo conmigo."
    ],
      [
      "Hoy toco la necesidad debajo de la dificultad.",
      "No resuelvo.",
      "Me quedo conmigo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Pongo una mano en el pecho.",
      "Una respiración."
    ],
      [
      "Pongo una mano en el pecho.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué necesito para sentirme un poco más vivo/a?",
      "¿Qué en mí pide calor o cercanía?",
      "¿Cómo se siente cuando me doy un momento?"
    ],
      [
      "¿Qué necesito para sentirme un poco más vivo/a?",
      "¿Qué en mí pide calor o cercanía?",
      "¿Cómo se siente cuando me doy un momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Detrás de la dificultad hay una petición."
    ],
      [
      "Detrás de la dificultad hay una petición."
    ]
    ),
    action: localizedGenderNode(
      "escribir una petición para mí.",
      "escribir una petición para mí."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Una pequeña conexión",
    opening: localizedGenderNode(
      [
      "Hoy busco una pequeña conexión dentro de mí.",
      "No grande, solo posible.",
      "Estoy aquí."
    ],
      [
      "Hoy busco una pequeña conexión dentro de mí.",
      "No grande, solo posible.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento la espalda apoyada.",
      "Una respiración."
    ],
      [
      "Siento la espalda apoyada.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me da sensación de conexión ahora?",
      "¿Qué palabra me calma?",
      "¿Qué puedo darme por un momento?"
    ],
      [
      "¿Qué me da sensación de conexión ahora?",
      "¿Qué palabra me calma?",
      "¿Qué puedo darme por un momento?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una pequeña conexión sigue siendo conexión."
    ],
      [
      "Una pequeña conexión sigue siendo conexión."
    ]
    ),
    action: localizedGenderNode(
      "una palabra tranquila en mi corazón.",
      "una palabra tranquila en mi corazón."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Compasión hacia mí",
    opening: localizedGenderNode(
      [
      "Hoy me hablo con suavidad.",
      "No como un juez.",
      "Estoy aquí."
    ],
      [
      "Hoy me hablo con suavidad.",
      "No como un juez.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Suavizo la mandíbula.",
      "Una respiración."
    ],
      [
      "Suavizo la mandíbula.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cómo le hablaría a un amigo aquí?",
      "¿Qué frase suave necesito escuchar?",
      "¿Qué puedo perdonarme?"
    ],
      [
      "¿Cómo le hablaría a un amigo aquí?",
      "¿Qué frase suave necesito escuchar?",
      "¿Qué puedo perdonarme?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "La suavidad no cancela la dificultad."
    ],
      [
      "La suavidad no cancela la dificultad."
    ]
    ),
    action: localizedGenderNode(
      "una frase suave para mí.",
      "una frase suave para mí."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Una petición interna",
    opening: localizedGenderNode(
      [
      "Hoy me doy una petición clara.",
      "No una exigencia, solo una petición.",
      "Estoy aquí."
    ],
      [
      "Hoy me doy una petición clara.",
      "No una exigencia, solo una petición.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento el abdomen aflojar un poco.",
      "Una respiración."
    ],
      [
      "Siento el abdomen aflojar un poco.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuál es mi petición más importante ahora?",
      "¿Cómo decirla en una sola frase?",
      "¿Qué estoy dispuesto/a a darme a cambio?"
    ],
      [
      "¿Cuál es mi petición más importante ahora?",
      "¿Cómo decirla en una sola frase?",
      "¿Qué estoy dispuesto/a a darme a cambio?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Una petición puede ayudarme a moverme."
    ],
      [
      "Una petición puede ayudarme a moverme."
    ]
    ),
    action: localizedGenderNode(
      "escribir la petición en una frase corta.",
      "escribir la petición en una frase corta."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Un valor suave",
    opening: localizedGenderNode(
      [
      "Hoy me recuerdo un valor pequeño que me sostiene.",
      "No grande.",
      "Estoy aquí."
    ],
      [
      "Hoy me recuerdo un valor pequeño que me sostiene.",
      "No grande.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Noto el rostro más calmado.",
      "Una respiración."
    ],
      [
      "Noto el rostro más calmado.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué valor pequeño me importa ahora?",
      "¿Cómo se ve ese valor en un día normal?",
      "¿Qué pequeño paso interno lo honra?"
    ],
      [
      "¿Qué valor pequeño me importa ahora?",
      "¿Cómo se ve ese valor en un día normal?",
      "¿Qué pequeño paso interno lo honra?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Un valor pequeño me da dirección."
    ],
      [
      "Un valor pequeño me da dirección."
    ]
    ),
    action: localizedGenderNode(
      "elegir un valor y repetirlo en mi corazón.",
      "elegir un valor y repetirlo en mi corazón."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Cómo estoy conmigo",
    opening: localizedGenderNode(
      [
      "Hoy observo cómo me trato.",
      "No juzgo.",
      "Estoy aquí."
    ],
      [
      "Hoy observo cómo me trato.",
      "No juzgo.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me doy medio minuto de silencio.",
      "Una respiración."
    ],
      [
      "Me doy medio minuto de silencio.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo me presiono a mí mismo/a?",
      "¿Dónde puedo aflojar un poco?",
      "¿Cómo quiero hablarme en el futuro?"
    ],
      [
      "¿Cuándo me presiono a mí mismo/a?",
      "¿Dónde puedo aflojar un poco?",
      "¿Cómo quiero hablarme en el futuro?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cómo estoy conmigo importa."
    ],
      [
      "Cómo estoy conmigo importa."
    ]
    ),
    action: localizedGenderNode(
      "una frase de respeto hacia mí.",
      "una frase de respeto hacia mí."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Un pequeño cambio",
    opening: localizedGenderNode(
      [
      "Hoy elijo un pequeño cambio que puedo sostener.",
      "No una revolución.",
      "Estoy aquí."
    ],
      [
      "Hoy elijo un pequeño cambio que puedo sostener.",
      "No una revolución.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento el cuerpo estable por un momento.",
      "Una respiración."
    ],
      [
      "Siento el cuerpo estable por un momento.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué pequeño cambio podría ayudarme en la mañana?",
      "¿Cómo se vería en la práctica?",
      "¿Qué estoy dispuesto/a a intentar una vez?"
    ],
      [
      "¿Qué pequeño cambio podría ayudarme en la mañana?",
      "¿Cómo se vería en la práctica?",
      "¿Qué estoy dispuesto/a a intentar una vez?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Lo pequeño suficiente es suficiente."
    ],
      [
      "Lo pequeño suficiente es suficiente."
    ]
    ),
    action: localizedGenderNode(
      "un paso pequeño para mí.",
      "un paso pequeño para mí."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Frase de regreso",
    opening: localizedGenderNode(
      [
      "Hoy cierro con suavidad.",
      "Elijo una frase que me devuelve.",
      "Estoy aquí."
    ],
      [
      "Hoy cierro con suavidad.",
      "Elijo una frase que me devuelve.",
      "Estoy aquí."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Siento el aire entrar y salir.",
      "Una respiración."
    ],
      [
      "Siento el aire entrar y salir.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué aprendí sobre esta dificultad?",
      "¿Cuál es la señal más temprana de que sube?",
      "¿Qué frase me devuelve al momento anterior?"
    ],
      [
      "¿Qué aprendí sobre esta dificultad?",
      "¿Cuál es la señal más temprana de que sube?",
      "¿Qué frase me devuelve al momento anterior?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Elijo presencia antes de reaccionar."
    ],
      [
      "Elijo presencia antes de reaccionar."
    ]
    ),
    action: localizedGenderNode(
      "una respiración y mi frase de regreso.",
      "una respiración y mi frase de regreso."
    ),
  },
].map(buildNormalizedDay);

export const difficultyGettingUpInTheMorningFeelingThatThereIsAReasonBlueprintEs = buildNormalizedPilotBlueprint({
  id: "difficulty_getting_up_in_the_morning_feeling_that_there_is_a_reason_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "difficulty_getting_up_in_the_morning_feeling_that_there_is_a_reason",
  category: "depression_emptiness_meaning",
  journeyName: {
    he: "קושי לקום בבוקר / להרגיש שיש למה",
    en: "Difficulty getting up in the morning / feeling that there is a reason",
    es: "Dificultad para levantarse por la mañana / sentir que hay una razón",
  },
  days,
});

export default difficultyGettingUpInTheMorningFeelingThatThereIsAReasonBlueprintEs;
